import { Link } from '@remix-run/react'

const LinkWrapper: React.FC<any> = ({ href = '', children, ...rest }) => {
	console.log(href)
	return (
		<Link
			{...rest}
			to={
				String(href)[0] === '/' ? href.replace(/^(?!.*http:)\/*\//g, '/') : href
			}
		>
			{children}
		</Link>
	)
}

export default LinkWrapper
